import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './context/store';
import { ToastContainer } from 'react-toastify';

// React.StrictMode
ReactDOM.render(<>
  <>
    <Provider store={store}>
      <App />
      <ToastContainer />
    </Provider>
  </>
</>, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
